var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLefticon = function SvgLefticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.895 7.643v.714c0 .198-.16.357-.357.357H3.984l3.18 3.173a.357.357 0 0 1 0 .507l-.508.5a.357.357 0 0 1-.507 0l-4.387-4.38a.536.536 0 0 1-.157-.378v-.272a.55.55 0 0 1 .157-.378l4.387-4.38a.357.357 0 0 1 .507 0l.508.507a.35.35 0 0 1 0 .5l-3.18 3.172h11.554c.197 0 .357.16.357.358Z"
  })));
};
export default SvgLefticon;